import React from 'react'
import * as R from 'ramda'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import RaisedButton from 'material-ui/RaisedButton'
import IconButton from 'material-ui/IconButton'
import Divider from 'material-ui/Divider'
import DropDownMenu from 'material-ui/DropDownMenu'
import Toggle from 'material-ui/Toggle'
import DatePicker from 'material-ui/DatePicker'
import AutoComplete from 'material-ui/AutoComplete'
import { sort } from 'utils/stuff'
import Checkbox from 'material-ui/Checkbox'
import Colors from 'material-ui/styles/colors'


export default (o) => (
	<div
		style={(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			{marginTop:  '24px', display: "block", marginLeft: "22px"}
			:{marginTop:  '10px', display: "block"}
	}>
    <div style={{
			height: "60px"
		  , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"0" : "-26px"
		  , verticalAlign: "middle"
		  , width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"100%":"30%"
		  , maxWidth: "100%"
		  , minWidth: "208px"
		  , paddingLeft: "8px"
		  , marginLeft: "-8px"

		}}
		className="filters"
	>
      <AutoComplete
				fullWidth={true}
        hintText="Property alias"
		title={(o.repairmenFilters.property && o.properties[o.repairmenFilters.property])? o.properties[o.repairmenFilters.property].address: ''}
        openOnFocus={true}
		filter={AutoComplete.caseInsensitiveFilter}
		className="no-underline"
		inputStyle={{
			fontSize: "14px"
		  , height: "45px"
		  , lineHeight: "43px"
		  , paddingLeft:"4px"
		  , bottom: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "6px" : "16px"
		}}
		hintStyle={{
			fontSize: "14px"
		  , bottom: "30px"
		  , paddingLeft:"4px"
		}}
		menuStyle={{
			maxHeight: "400px"
		  , overflowY: "auto"
		}}
        dataSource={
			[...[{
				text: 'All'
				, value: (
                  <MenuItem
                    primaryText={"All"}
                    key={`Property-all-filters`}
                  />
                )
				, id: 'All'
			}],
			...((o.properties)?
            R.map((property) => ({
              text: property.alias,
              value: (
                <MenuItem
                  primaryText={property.alias}
                  key={`Property-${property._id}-filters`}
                />
              ),
              id: property._id
		  }),  sort(o.properties, "alias"))
          : [{text: '', value: ''}])
	  		]
        }
        onNewRequest={(obj)=> o.filtersUPD({property: obj.id})}
      />
    </div>
	<div
		style={{
			height: "60px"
		   , verticalAlign: "middle"
		   , width: "30%"
		   , maxWidth: "100%"
		   , minWidth: "208px"
		   , paddingLeft: "8px"
		   , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"4px" : "-25px"
		   , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"-8px":"auto"
		   , textAlign: "center"
		 }}
		 className="filters no-underline"
	>
		<SelectField
			style={{
				width: (typeof global.md.phone() != "string")? "30%" : "100%"
  			  , backgroundColor: "#FFF"
			  , paddingLeft: "10px"
			  , textAlign: "center"
			  , zIndex: '1230000'
			}}
			labelStyle={{
			   fontSize: "14px"
			  , lineHeight: "43px"
			  , textAlign: "center"
			  , color: "#000"
			  , paddingLeft: "4px"
			  , position: "relative"
			  , display: "table"
			  , textAlign: "left"
			  , top:(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"-2px":"0px"
			}}
			iconStyle={{
				top: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"8px":"10px"
			  , right: "10px"
			}}
			hintStyle={{
				fontSize: "14px"
			  , bottom: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"14px":"11px"
			  , paddingLeft: "4px"
			}}
			fullWidth={true}
			style={{
				height: "45px"
			}}
			value={o.yelpCategory}
			hintText = "Select category"
			menuItemStyle={{

			}}
			onChange={(evt, index, value) => {

					o.filtersUPD({category: value})
					o.updCategoryYelp(value)
				}}
			>
			<MenuItem key={0} value={"All"} style={{}} primaryText="All" />
			<MenuItem key={1} value={"Carpet Installation"} style={{}} primaryText="Carpet Installation" />
			<MenuItem key={2} value={"Carpeting"} primaryText="Carpeting" />
			<MenuItem key={3} value={"Chimney Sweeps"} primaryText="Chimney Sweeps" />
			<MenuItem key={4} value={"Contractors"} primaryText="Contractors" />
			<MenuItem key={5} value={"Damage Restoration"} primaryText="Damage Restoration" />
			<MenuItem key={6} value={"Drywall Installation & Repair"} primaryText="Drywall Installation & Repair" />
			<MenuItem key={7} value={"Electricians"} primaryText="Electricians" />
			<MenuItem key={8} value={"Fences & Gates"} primaryText="Fences & Gates" />
			<MenuItem key={9} value={"Fireplace Services"} primaryText="Fireplace Services" />
			<MenuItem key={10} value={"Flooring"} primaryText="Flooring" />
			<MenuItem key={11} value={"Garage Door Services"} primaryText="Garage Door Services" />
			<MenuItem key={12} value={"Gardeners"} primaryText="Gardeners" />
			<MenuItem key={13} value={"Gutter Services"} primaryText="Gutter Services" />
			<MenuItem key={14} value={"Handyman"} primaryText="Handyman" />
			<MenuItem key={15} value={"Heating & Air Conditioning/HVAC"} primaryText="Heating & Air Conditioning/HVAC" />
			<MenuItem key={16} value={"Home Cleaning"} primaryText="Home Cleaning" />
			<MenuItem key={17} value={"Home Inspectors"} primaryText="Home Inspectors" />
			<MenuItem key={18} value={"Keys & Locksmiths"} primaryText="Keys & Locksmiths" />
			<MenuItem key={19} value={"Landscaping"} primaryText="Landscaping" />
			<MenuItem key={20} value={"Movers"} primaryText="Movers" />
			<MenuItem key={21} value={"Painters"} primaryText="Painters" />
			<MenuItem key={22} value={"Plumbing"} primaryText="Plumbing" />
			<MenuItem key={23} value={"Pool Cleaners"} primaryText="Pool Cleaners" />
			<MenuItem key={24} value={"Roofing"} primaryText="Roofing" />
			<MenuItem key={25} value={"Stucco Services"} primaryText="Stucco Services" />
			<MenuItem key={26} value={"Tiling"} primaryText="Tiling" />
			<MenuItem key={27} value={"Tree Services"} primaryText="Tree Services" />
			<MenuItem key={28} value={"Water Heater Installation/Repair"} primaryText="Water Heater Installation/Repair" />
			<MenuItem key={29} value={"Window Washing"} primaryText="Window Washing" />

		</SelectField>
	</div>
	<div
		className="include-yelp-filter"
		style={(typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?
			  {marginTop:"-30px", marginLeft: "-20px"}
			  :{}
	}>
		<Checkbox
			label="Include Yelp Results"
			checked={o.yelpIsOn}
			onCheck={o.switchYelp}
			labelStyle={{
				color: "#9da8ad"
			  , textAlign: "left"
			}}
			iconStyle={{
				color: "#00d4b3"
			  , fill: "#00d4b3"
			}}
			style={{
				marginLeft: "50px"
	 		   , marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"35px" : "auto"
			}}
		/>
	</div>
  </div>
)



// WEBPACK FOOTER //
// ./src/routes/manager/repairmen/RepairmenFilters.js